import { useState } from "react";
import "../Check-inFlow/checkin.css";
import "./Analytics.css";

const Icon = {
  dashboard: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M10 6V0H18V6H10ZM0 10V0H8V10H0ZM10 18V8H18V18H10ZM0 18V12H8V18H0ZM2 8H6V2H2V8ZM12 16H16V10H12V16ZM12 4H16V2H12V4ZM2 16H6V14H2V16Z" />
    </svg>
  ),
  vehicle: (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none">
      <path d="M3 14V15C3 15.2833 2.90417 15.5208 2.7125 15.7125C2.52083 15.9042 2.28333 16 2 16H1C0.716667 16 0.479167 15.9042 0.2875 15.7125C0.0958333 15.5208 0 15.2833 0 15V7L2.1 1C2.2 0.7 2.37917 0.458333 2.6375 0.275C2.89583 0.0916667 3.18333 0 3.5 0H14.5C14.8167 0 15.1042 0.0916667 15.3625 0.275C15.6208 0.458333 15.8 0.7 15.9 1L18 7V15C18 15.2833 17.9042 15.5208 17.7125 15.7125C17.5208 15.9042 17.2833 16 17 16H16C15.7167 16 15.4792 15.9042 15.2875 15.7125C15.0958 15.5208 15 15.2833 15 15V14H3ZM2.8 5H15.2L14.15 2H3.85L2.8 5ZM4.5 11C4.91667 11 5.27083 10.8542 5.5625 10.5625C5.85417 10.2708 6 9.91667 6 9.5C6 9.08333 5.85417 8.72917 5.5625 8.4375C5.27083 8.14583 4.91667 8 4.5 8C4.08333 8 3.72917 8.14583 3.4375 8.4375C3.14583 8.72917 3 9.08333 3 9.5C3 9.91667 3.14583 10.2708 3.4375 10.5625C3.72917 10.8542 4.08333 11 4.5 11ZM13.5 11C13.9167 11 14.2708 10.8542 14.5625 10.5625C14.8542 10.2708 15 9.91667 15 9.5C15 9.08333 14.8542 8.72917 14.5625 8.4375C14.2708 8.14583 13.9167 8 13.5 8C13.0833 8 12.7292 8.14583 12.4375 8.4375C12.1458 8.72917 12 9.08333 12 9.5C12 9.91667 12.1458 10.2708 12.4375 10.5625C12.7292 10.8542 13.0833 11 13.5 11ZM2 12H16V7H2V12Z" />
    </svg>
  ),
  checkin: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M8.55 17.1V15.2H15.2V1.9H8.55V0H15.2C15.7225 0 16.1698 0.186042 16.5419 0.558125C16.914 0.930208 17.1 1.3775 17.1 1.9V15.2C17.1 15.7225 16.914 16.1698 16.5419 16.5419C16.1698 16.914 15.7225 17.1 15.2 17.1H8.55ZM6.65 13.3L5.34375 11.9225L7.76625 9.5H0V7.6H7.76625L5.34375 5.1775L6.65 3.8L11.4 8.55L6.65 13.3Z" />
    </svg>
  ),
  checkout: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H9V2H2V16H9V18H2ZM13 14L11.625 12.55L14.175 10H6V8H14.175L11.625 5.45L13 4L18 9L13 14Z" />
    </svg>
  ),
  analytics: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M4 14H6V9H4V14ZM12 14H14V4H12V14ZM8 14H10V11H8V14ZM8 9H10V7H8V9ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V2H2V16Z" />
    </svg>
  ),
  settings: (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.3 20L6.9 16.8C6.68333 16.7167 6.47917 16.6167 6.2875 16.5C6.09583 16.3833 5.90833 16.2583 5.725 16.125L2.75 17.375L0 12.625L2.575 10.675C2.55833 10.5583 2.55 10.4458 2.55 10.3375C2.55 10.2292 2.55 10.1167 2.55 10C2.55 9.88333 2.55 9.77083 2.55 9.6625C2.55 9.55417 2.55833 9.44167 2.575 9.325L0 7.375L2.75 2.625L5.725 3.875C5.90833 3.74167 6.1 3.61667 6.3 3.5C6.5 3.38333 6.7 3.28333 6.9 3.2L7.3 0H12.8L13.2 3.2C13.4167 3.28333 13.6208 3.38333 13.8125 3.5C14.0042 3.61667 14.1917 3.74167 14.375 3.875L17.35 2.625L20.1 7.375L17.525 9.325C17.5417 9.44167 17.55 9.55417 17.55 9.6625C17.55 9.77083 17.55 9.88333 17.55 10C17.55 10.1167 17.55 10.2292 17.55 10.3375C17.55 10.4458 17.5333 10.5583 17.5 10.675L20.075 12.625L17.325 17.375L14.375 16.125C14.1917 16.2583 14 16.3833 13.8 16.5C13.6 16.6167 13.4 16.7167 13.2 16.8L12.8 20H7.3ZM9.05 18H11.025L11.375 15.35C11.8917 15.2167 12.3708 15.0208 12.8125 14.7625C13.2542 14.5042 13.6583 14.1917 14.025 13.825L16.5 14.85L17.475 13.15L15.325 11.525C15.4083 11.2917 15.4667 11.0458 15.5 10.7875C15.5333 10.5292 15.55 10.2667 15.55 10C15.55 9.73333 15.5333 9.47083 15.5 9.2125C15.4667 8.95417 15.4083 8.70833 15.325 8.475L17.475 6.85L16.5 5.15L14.025 6.2C13.6583 5.81667 13.2542 5.49583 12.8125 5.2375C12.3708 4.97917 11.8917 4.78333 11.375 4.65L11.05 2H9.075L8.725 4.65C8.20833 4.78333 7.72917 4.97917 7.2875 5.2375C6.84583 5.49583 6.44167 5.80833 6.075 6.175L3.6 5.15L2.625 6.85L4.775 8.45C4.69167 8.7 4.63333 8.95 4.6 9.2C4.56667 9.45 4.55 9.71667 4.55 10C4.55 10.2667 4.56667 10.525 4.6 10.775C4.63333 11.025 4.69167 11.275 4.775 11.525L2.625 13.15L3.6 14.85L6.075 13.8C6.44167 14.1833 6.84583 14.5042 7.2875 14.7625C7.72917 15.0208 8.20833 15.2167 8.725 15.35L9.05 18ZM10.1 13.5C11.0667 13.5 11.8917 13.1583 12.575 12.475C13.2583 11.7917 13.6 10.9667 13.6 10C13.6 9.03333 13.2583 8.20833 12.575 7.525C11.8917 6.84167 11.0667 6.5 10.1 6.5C9.11667 6.5 8.2875 6.84167 7.6125 7.525C6.9375 8.20833 6.6 9.03333 6.6 10C6.6 10.9667 6.9375 11.7917 7.6125 12.475C8.2875 13.1583 9.11667 13.5 10.1 13.5Z" fill="white"/>
</svg>

  ),
  caricon: (
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
<rect width="26.681" height="26.681" fill="url(#pattern0_1_5620)"/>
<defs>
<pattern id="pattern0_1_5620" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlinkHref="#image0_1_5620" transform="scale(0.01)"/>
</pattern>
<image id="image0_1_5620" width="100" height="100" preserveAspectRatio="none" xlinkHref="data:image/png;base64,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"/>
</defs>
</svg>
  ),
  bikeicon: (
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
<rect width="26.681" height="26.681" fill="url(#pattern0_1_5635)"/>
<defs>
<pattern id="pattern0_1_5635" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlinkHref="#image0_1_5635" transform="scale(0.01)"/>
</pattern>
<image id="image0_1_5635" width="100" height="100" preserveAspectRatio="none" xlinkHref="data:image/png;base64,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"/>
</defs>
</svg>
  ),
  plusicon: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 10H0V7.5H7.5V0H10V7.5H17.5V10H10V17.5H7.5V10Z" fill="white"/>
</svg>
  ),
  downicon: (
    <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.2186 5.2186C5.08593 5.35123 4.90601 5.42574 4.71841 5.42574C4.53081 5.42574 4.35089 5.35123 4.21822 5.2186L0.215986 1.21637C0.148415 1.1511 0.0945168 1.07304 0.0574383 0.986722C0.0203598 0.900406 0.000843017 0.80757 2.6712e-05 0.713631C-0.000789593 0.619692 0.0171111 0.526531 0.052684 0.439584C0.0882569 0.352637 0.14079 0.273644 0.207217 0.207217C0.273645 0.140789 0.352636 0.0882565 0.439583 0.0526837C0.52653 0.0171108 0.619692 -0.000789593 0.713631 2.67125e-05C0.80757 0.000843018 0.900406 0.0203598 0.986721 0.0574383C1.07304 0.0945168 1.1511 0.148414 1.21637 0.215986L4.71841 3.71803L8.22045 0.215986C8.35388 0.0871123 8.53259 0.015802 8.71809 0.0174139C8.90359 0.0190259 9.08104 0.093431 9.21221 0.224604C9.34338 0.355777 9.41779 0.533223 9.4194 0.718723C9.42101 0.904222 9.3497 1.08293 9.22083 1.21637L5.2186 5.2186Z" fill="black"/>
</svg>
  ),
  clockicon: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3 14.7L14.7 13.3L11 9.6V5H9V10.4L13.3 14.7ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20ZM10 18C12.2167 18 14.1042 17.2208 15.6625 15.6625C17.2208 14.1042 18 12.2167 18 10C18 7.78333 17.2208 5.89583 15.6625 4.3375C14.1042 2.77917 12.2167 2 10 2C7.78333 2 5.89583 2.77917 4.3375 4.3375C2.77917 5.89583 2 7.78333 2 10C2 12.2167 2.77917 14.1042 4.3375 15.6625C5.89583 17.2208 7.78333 18 10 18Z" fill="#432DD7"/>
</svg>
  ),
  calendaricon: (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6ZM2 6V4V6Z" fill="#432DD7"/>
</svg>
  ),
  uparrowicon: (
    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.816667 7L0 6.18333L4.31667 1.8375L6.65 4.17083L9.68333 1.16667H8.16667V0H11.6667V3.5H10.5V1.98333L6.65 5.83333L4.31667 3.5L0.816667 7Z" fill="#16A34A"/>
</svg>

  ),
  downarrowicon: (
    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.16667 7V5.83333H9.68333L6.65 2.82917L4.31667 5.1625L0 0.816667L0.816667 0L4.31667 3.5L6.65 1.16667L10.5 5.01667V3.5H11.6667V7H8.16667Z" fill="#B41340"/>
</svg>

  ),
  vehicleicon: (
    <svg width="54" height="48" viewBox="0 0 54 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 42V45C9 45.85 8.7125 46.5625 8.1375 47.1375C7.5625 47.7125 6.85 48 6 48H3C2.15 48 1.4375 47.7125 0.8625 47.1375C0.2875 46.5625 0 45.85 0 45V21L6.3 3C6.6 2.1 7.1375 1.375 7.9125 0.825C8.6875 0.275 9.55 0 10.5 0H43.5C44.45 0 45.3125 0.275 46.0875 0.825C46.8625 1.375 47.4 2.1 47.7 3L54 21V45C54 45.85 53.7125 46.5625 53.1375 47.1375C52.5625 47.7125 51.85 48 51 48H48C47.15 48 46.4375 47.7125 45.8625 47.1375C45.2875 46.5625 45 45.85 45 45V42H9ZM8.4 15H45.6L42.45 6H11.55L8.4 15ZM6 21V36V21ZM13.5 33C14.75 33 15.8125 32.5625 16.6875 31.6875C17.5625 30.8125 18 29.75 18 28.5C18 27.25 17.5625 26.1875 16.6875 25.3125C15.8125 24.4375 14.75 24 13.5 24C12.25 24 11.1875 24.4375 10.3125 25.3125C9.4375 26.1875 9 27.25 9 28.5C9 29.75 9.4375 30.8125 10.3125 31.6875C11.1875 32.5625 12.25 33 13.5 33ZM40.5 33C41.75 33 42.8125 32.5625 43.6875 31.6875C44.5625 30.8125 45 29.75 45 28.5C45 27.25 44.5625 26.1875 43.6875 25.3125C42.8125 24.4375 41.75 24 40.5 24C39.25 24 38.1875 24.4375 37.3125 25.3125C36.4375 26.1875 36 27.25 36 28.5C36 29.75 36.4375 30.8125 37.3125 31.6875C38.1875 32.5625 39.25 33 40.5 33ZM6 36H48V21H6V36Z" fill="#F5F1FF"/>
</svg>
  ),
  mailicon: (
    <svg width="68" height="72" viewBox="0 0 68 72" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M14.5439 49.2256C14.5439 48.3355 14.8976 47.4818 15.527 46.8524C16.1564 46.2229 17.0101 45.8693 17.9002 45.8693H49.2256C50.1157 45.8693 50.9694 46.2229 51.5989 46.8524C52.2283 47.4818 52.5819 48.3355 52.5819 49.2256C52.5819 50.1158 52.2283 50.9694 51.5989 51.5989C50.9694 52.2283 50.1157 52.5819 49.2256 52.5819H17.9002C17.0101 52.5819 16.1564 52.2283 15.527 51.5989C14.8976 50.9694 14.5439 50.1158 14.5439 49.2256ZM14.5439 62.6508C14.5439 61.7606 14.8976 60.9069 15.527 60.2775C16.1564 59.6481 17.0101 59.2945 17.9002 59.2945H49.2256C50.1157 59.2945 50.9694 59.6481 51.5989 60.2775C52.2283 60.9069 52.5819 61.7606 52.5819 62.6508C52.5819 63.5409 52.2283 64.3946 51.5989 65.024C50.9694 65.6535 50.1157 66.0071 49.2256 66.0071H17.9002C17.0101 66.0071 16.1564 65.6535 15.527 65.024C14.8976 64.3946 14.5439 63.5409 14.5439 62.6508Z" fill="#BCB5EF"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M0 8.95011C0 4.0186 4.0186 0 8.95011 0H38.8882C41.4032 0 43.775 1.06506 45.4442 2.82376L45.471 2.85508L64.7674 23.8968C66.374 25.6107 67.1258 27.8527 67.1258 29.9829V76.0759C67.1258 81.0074 63.1072 85.026 58.1757 85.026H8.95011C4.0186 85.026 0 81.0074 0 76.0759V8.95011ZM38.8837 8.95011H8.95011V76.0759H58.1757V29.9471L38.9509 8.98143L38.9374 8.97696L38.8837 8.95011Z" fill="#BCB5EF"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M38.8881 0C40.075 0 41.2132 0.471478 42.0525 1.31071C42.8917 2.14995 43.3632 3.28819 43.3632 4.47505V25.5078H62.6507C63.2383 25.5078 63.8203 25.6236 64.3632 25.8484C64.9061 26.0733 65.3995 26.403 65.815 26.8185C66.2306 27.2341 66.5602 27.7274 66.7851 28.2703C67.01 28.8133 67.1257 29.3952 67.1257 29.9829C67.1257 30.5705 67.01 31.1524 66.7851 31.6954C66.5602 32.2383 66.2306 32.7316 65.815 33.1472C65.3995 33.5627 64.9061 33.8924 64.3632 34.1173C63.8203 34.3422 63.2383 34.4579 62.6507 34.4579H38.8881C37.7013 34.4579 36.563 33.9864 35.7238 33.1472C34.8846 32.308 34.4131 31.1697 34.4131 29.9829V4.47505C34.4131 3.28819 34.8846 2.14995 35.7238 1.31071C36.563 0.471478 37.7013 0 38.8881 0Z" fill="#BCB5EF"/>
</svg>

  ),
  calendarpopicon: (
    <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.16667 11.6667C0.845833 11.6667 0.571181 11.5524 0.342708 11.324C0.114236 11.0955 0 10.8208 0 10.5V2.33333C0 2.0125 0.114236 1.73785 0.342708 1.50937C0.571181 1.2809 0.845833 1.16667 1.16667 1.16667H1.75V0H2.91667V1.16667H7.58333V0H8.75V1.16667H9.33333C9.65417 1.16667 9.92882 1.2809 10.1573 1.50937C10.3858 1.73785 10.5 2.0125 10.5 2.33333V10.5C10.5 10.8208 10.3858 11.0955 10.1573 11.324C9.92882 11.5524 9.65417 11.6667 9.33333 11.6667H1.16667ZM1.16667 10.5H9.33333V4.66667H1.16667V10.5ZM1.16667 3.5H9.33333V2.33333H1.16667V3.5ZM1.16667 3.5V2.33333V3.5Z" fill="#33284F"/>
</svg>
  ),
  downpopicon: (
    <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.37629 7.37629C7.18876 7.56376 6.93445 7.66907 6.66929 7.66907C6.40412 7.66907 6.14982 7.56376 5.96229 7.37629L0.305288 1.71929C0.209778 1.62704 0.133596 1.5167 0.0811869 1.39469C0.0287779 1.27269 0.00119157 1.14147 3.77564e-05 1.00869C-0.00111606 0.87591 0.0241859 0.744231 0.0744668 0.621335C0.124748 0.498438 0.199001 0.386786 0.292893 0.292893C0.386786 0.199 0.498438 0.124747 0.621334 0.0744663C0.744231 0.0241854 0.87591 -0.00111606 1.00869 3.77571e-05C1.14147 0.00119157 1.27269 0.0287779 1.39469 0.0811869C1.5167 0.133596 1.62704 0.209778 1.71929 0.305288L6.66929 5.25529L11.6193 0.305288C11.8079 0.12313 12.0605 0.0223355 12.3227 0.0246139C12.5849 0.0268924 12.8357 0.132061 13.0211 0.317469C13.2065 0.502877 13.3117 0.75369 13.314 1.01589C13.3162 1.27808 13.2154 1.53069 13.0333 1.71929L7.37629 7.37629Z" fill="black"/>
</svg>

  ),
  pdfpopicon: (
    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.11475 12.073L9.30225 13.2605M8.51058 10.4897C8.51058 11.0146 8.30206 11.518 7.9309 11.8891C7.55973 12.2603 7.05632 12.4688 6.53141 12.4688C6.00651 12.4688 5.5031 12.2603 5.13193 11.8891C4.76076 11.518 4.55225 11.0146 4.55225 10.4897C4.55225 9.96476 4.76076 9.46135 5.13193 9.09018C5.5031 8.71902 6.00651 8.5105 6.53141 8.5105C7.05632 8.5105 7.55973 8.71902 7.9309 9.09018C8.30206 9.46135 8.51058 9.96476 8.51058 10.4897Z" stroke="#33284F" stroke-width="1.1875" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.71875 0.989644V1.38548C7.71875 3.62431 7.71875 4.74452 8.41462 5.4396C9.10971 6.13548 10.2299 6.13548 12.4688 6.13548H12.8646M13.2604 7.44727V10.0938C13.2604 13.0792 13.2604 14.5723 12.3326 15.4993C11.4047 16.4264 9.91246 16.4271 6.92708 16.4271C3.94171 16.4271 2.44862 16.4271 1.52158 15.4993C0.594542 14.5715 0.59375 13.0792 0.59375 10.0938V6.49648C0.59375 3.92752 0.59375 2.64264 1.29517 1.7726C1.43683 1.59692 1.59686 1.43689 1.77254 1.29523C2.64417 0.593811 3.92746 0.593811 6.49642 0.593811C7.05454 0.593811 7.334 0.593811 7.58971 0.684061C7.64249 0.703061 7.69447 0.7247 7.74567 0.748978C7.99108 0.866144 8.18821 1.06327 8.58325 1.45831L12.3326 5.20764C12.791 5.66523 13.019 5.89481 13.1401 6.18535C13.2604 6.47669 13.2604 6.79969 13.2604 7.44727Z" stroke="#33284F" stroke-width="1.1875" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  ),
  downloadpopicon: (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.75 12.254V13.25C0.75 14.0456 1.06607 14.8087 1.62868 15.3713C2.19129 15.9339 2.95435 16.25 3.75 16.25H13.75C14.5456 16.25 15.3087 15.9339 15.8713 15.3713C16.4339 14.8087 16.75 14.0456 16.75 13.25V12.25M8.75 0.75V11.75M5.25 8.25L8.75 11.75L12.25 8.25" stroke="#F5F1FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  ),
};

function Analytics({ setPage }) {
  const [activeMenu, setActiveMenu] = useState("Analytics");
  const [showReportPopup, setShowReportPopup] = useState(false);
const [reportType, setReportType] = useState("Daily");

  return (
    <div className="analytics-page">
      <aside className="checkin-sidebar">
        <div className="checkin-menu">
          {[
            ["Dashboard", Icon.dashboard],
            ["Vehicles", Icon.vehicle],
            ["Check-In", Icon.checkin],
            ["Check-Out", Icon.checkout],
            ["Analytics", Icon.analytics],
            ["Settings", Icon.settings],
          ].map(([name, icon]) => (
            <button
              key={name}
              className={
                activeMenu === name
                  ? "checkin-menu-item checkin-active"
                  : "checkin-menu-item"
              }
              onClick={() => {
  if (name === "Dashboard") {
    setActiveMenu("Dashboard");
    setPage("dashboard");
  }

  if (name === "Vehicles") {
    setActiveMenu("Vehicles");
    setPage("vehicle");   // use "vehicle" if that's what App.js uses
  }

  if (name === "Check-In") {
    setActiveMenu("Check-In");
    setPage("checkin");
  }

  if (name === "Check-Out") {
  // do nothing
  return;
}

  if (name === "Analytics") {
    setActiveMenu("Analytics");
    // Do NOT call setPage("analytics")
    // You are already on the Analytics page.
  }

  if (name === "Settings") {
    setActiveMenu("Settings");
    setPage("settings");
  }
}}
            >
              {icon}
              {name}
            </button>
          ))}
        </div>
      </aside>

      <main className="analytics-main">
        <div className="analytics-top">
          <div>
            <h1 className="analytics-title">Analytics</h1>
            <p className="analytics-desc">
              Displays the reports of vehicles and bills
            </p>
          </div>

          <div className="analytics-top-actions">
            <button className="analytics-select-btn">Week <span className="analytics-down-icon">
  {Icon.downicon}
</span></button>
            <button className="analytics-select-btn">First Floor <span className="analytics-down-icon">
  {Icon.downicon}
</span></button>
          </div>
        </div>

        <section className="analytics-summary-area">
  <div className="analytics-summary-card">
    <div className="analytics-card-head">
      <span>TOTAL AVAILABLE</span>
      <span className="analytics-live">LIVE</span>
    </div>

    <div className="analytics-number-row">
  <h2>120</h2>
</div>

<div className="analytics-progress-row">
  <div className="analytics-progress-track">
    <div style={{ width: "34%" }}></div>
  </div>
  <span className="analytics-progress-value">20.2%</span>
</div>
  </div>

  <div className="analytics-summary-card">
    <div className="analytics-card-head">
      <span>AVAIL. CAR SPOTS</span>
      <span className="analytics-card-icon">
  {Icon.caricon}
</span>
    </div>

    <div className="analytics-number-row">
  <h2>30</h2>
</div>

<div className="analytics-progress-row">
  <div className="analytics-progress-track">
    <div style={{ width: "34.3%" }}></div>
  </div>
  <span className="analytics-progress-value">34.3%</span>
</div>
  </div>

  <div className="analytics-summary-card">
    <div className="analytics-card-head">
      <span>AVAIL. BIKE SPOTS</span>
      <span className="analytics-card-icon">
  {Icon.bikeicon}
</span>
    </div>

    <div className="analytics-number-row">
  <h2>90</h2>
</div>

<div className="analytics-progress-row">
  <div className="analytics-progress-track">
    <div style={{ width: "75%" }}></div>
  </div>
  <span className="analytics-progress-value">75%</span>
</div>
  </div>

  
</section>

        <section className="analytics-placeholder-grid">
          <div className="analytics-card analytics-parking-card">
  <p className="analytics-card-label">TOTAL VEHICLES</p>
  <h3 className="analytics-chart-title">Most Parkings - This Week</h3>

  <div className="analytics-bar-chart">
    <div className="analytics-y-axis">
      <span>250</span>
      <span>200</span>
      <span>150</span>
      <span>100</span>
      <span>50</span>
      <span>0</span>
    </div>

    <div className="analytics-chart-area">
      <div className="analytics-grid-lines">
        <span></span><span></span><span></span><span></span><span></span>
      </div>

      {[
        ["Mon", 170, "gray"],
        ["Tue", 205, "gray"],
        ["Wed", 120, "gray"],
        ["Thu", 170, "gray"],
        ["Fri", 250, "purple"],
        ["Sat", 170, "gray"],
        ["Sun", 60, "red"],
      ].map(([day, height, type]) => (
        <div className="analytics-bar-item" key={day}>
          <div
            className={`analytics-parking-bar analytics-${type}-bar`}
            style={{ height: `${height}px` }}
          ></div>
          <span>{day}</span>
        </div>
      ))}
    </div>
  </div>
</div>

          <div className="analytics-card analytics-ratio-card">
  <p className="analytics-card-label">TOTAL VEHICLES</p>

  <h3 className="analytics-ratio-title">Vehicles Ratio</h3>

  <div className="analytics-donut-wrapper">
  {<svg width="175" height="155" viewBox="0 0 175 155" fill="none" xmlns="http://www.w3.org/2000/svg"> <mask id="mask0_1_5428" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="82" y="4" width="93" height="151"> <path fillRule="evenodd" clipRule="evenodd" d="M82.7462 148.717C82.2017 150.748 83.4334 152.84 85.4998 153.234C90.0764 154.107 94.8005 154.563 99.6313 154.563C141.057 154.563 174.639 120.981 174.639 79.5553C174.639 40.2749 144.445 8.04662 106.001 4.81388C103.889 4.63629 102.132 6.34397 102.132 8.46338L102.132 38.6216C102.132 40.5973 103.67 42.2138 105.621 42.5269C123.487 45.3944 137.135 60.8809 137.135 79.5553C137.135 100.268 120.344 117.059 99.6313 117.059C98.0651 117.059 96.5212 116.963 95.0054 116.777C93.0123 116.532 91.0577 117.697 90.538 119.637L82.7462 148.717Z" fill="url(#paint0_linear_1_5428)"/> </mask> <g mask="url(#mask0_1_5428)"> <path fill-rule="evenodd" clip-rule="evenodd" d="M82.7471 148.717C82.2027 150.748 83.4344 152.84 85.5007 153.234C90.0774 154.107 94.8015 154.563 99.6323 154.563C141.058 154.563 174.64 120.981 174.64 79.5553C174.64 39.9866 152.817 9.27566 114.412 6.5346C112.662 6.4097 111.095 7.58532 110.655 9.28352L103.271 37.7468C102.68 40.0239 104.316 42.2664 106.628 42.7025C123.998 45.9795 137.136 61.233 137.136 79.5553C137.136 100.268 120.345 117.059 99.6323 117.059C98.066 117.059 96.5222 116.963 95.0063 116.777C93.0133 116.532 91.0587 117.697 90.539 119.637L82.7471 148.717Z" fill="url(#paint1_linear_1_5428)"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M82.7471 148.717C82.2027 150.748 83.4344 152.84 85.5007 153.234C90.0774 154.107 94.8015 154.563 99.6323 154.563C141.058 154.563 174.64 120.981 174.64 79.5553C174.64 39.9866 152.817 9.27566 114.412 6.5346C112.662 6.4097 111.095 7.58532 110.655 9.28352L103.271 37.7468C102.68 40.0239 104.316 42.2664 106.628 42.7025C123.998 45.9795 137.136 61.233 137.136 79.5553C137.136 100.268 120.345 117.059 99.6323 117.059C98.066 117.059 96.5222 116.963 95.0063 116.777C93.0133 116.532 91.0587 117.697 90.539 119.637L82.7471 148.717Z" fill="#494949" style={{ mixBlendMode: "screen" }}/> </g> <mask id="mask1_1_5428" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="20" y="3" width="96" height="150"> <path fill-rule="evenodd" clip-rule="evenodd" d="M115.545 9.70545C116.175 7.69825 115.032 5.55655 112.984 5.07604C108.448 4.01179 103.747 3.35683 98.9209 3.15365C57.5317 1.41131 22.5668 33.5514 20.8244 74.9405C19.1723 114.186 47.9841 147.656 86.2587 152.503C88.3613 152.769 90.1888 151.137 90.2779 149.019L91.5464 118.888C91.6295 116.914 90.1605 115.234 88.2246 114.839C70.495 111.223 57.5098 95.1758 58.2953 76.5179C59.1664 55.8234 76.6489 39.7533 97.3435 40.6245C98.9084 40.6904 100.447 40.8512 101.953 41.1013C103.934 41.43 105.936 40.3475 106.537 38.4314L115.545 9.70545Z" fill="url(#paint2_linear_1_5428)"/> </mask> <g mask="url(#mask1_1_5428)"> <path fill-rule="evenodd" clip-rule="evenodd" d="M109.674 8.2928C110.115 6.59893 109.308 4.83656 107.611 4.4074C103.756 3.43249 98.7092 3.1455 98.9194 3.15398C57.5302 1.41163 22.5652 33.5517 20.8229 74.9408C19.1596 114.452 38.7739 146.927 76.9413 151.355C78.7135 151.561 80.3489 150.413 80.8331 148.696L85.3977 132.507L88.7708 119.014C89.3227 116.807 87.7874 114.636 85.5683 114.134C68.4931 110.271 57.5203 94.8919 58.2937 76.5182C59.1649 55.8237 76.6474 39.7536 97.342 40.6248C97.3645 40.6257 97.3868 40.6267 97.4088 40.6276C99.4869 40.7133 101.53 39.5852 102.054 37.5723L109.674 8.2928Z" fill="url(#paint3_linear_1_5428)"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M109.674 8.2928C110.115 6.59893 109.308 4.83656 107.611 4.4074C103.756 3.43249 98.7092 3.1455 98.9194 3.15398C57.5302 1.41163 22.5652 33.5517 20.8229 74.9408C19.1596 114.452 38.7739 146.927 76.9413 151.355C78.7135 151.561 80.3489 150.413 80.8331 148.696L85.3977 132.507L88.7708 119.014C89.3227 116.807 87.7874 114.636 85.5683 114.134C68.4931 110.271 57.5203 94.8919 58.2937 76.5182C59.1649 55.8237 76.6474 39.7536 97.342 40.6248C97.3645 40.6257 97.3868 40.6267 97.4088 40.6276C99.4869 40.7133 101.53 39.5852 102.054 37.5723L109.674 8.2928Z" fill="#30209B" style={{ mixBlendMode: "screen" }}/> </g> <defs> <linearGradient id="paint0_linear_1_5428" x1="174.639" y1="4.58813" x2="123.849" y2="58.4282" gradientUnits="userSpaceOnUse"> <stop/> <stop offset="1"/> </linearGradient> <linearGradient id="paint1_linear_1_5428" x1="128.198" y1="4.58811" x2="128.198" y2="154.563" gradientUnits="userSpaceOnUse"> <stop/> <stop offset="1" stopColor="#1C1C1C" stopOpacity="0.6"/> <stop offset="1" stop-opacity="0.6"/> </linearGradient> <linearGradient id="paint2_linear_1_5428" x1="17.6713" y1="149.841" x2="70.6811" y2="98.1851" gradientUnits="userSpaceOnUse"> <stop/> <stop offset="1"/> </linearGradient> <linearGradient id="paint3_linear_1_5428" x1="64.0727" y1="151.795" x2="70.3806" y2="1.95233" gradientUnits="userSpaceOnUse"> <stop/> <stop offset="1" stop-color="#1C1C1C" stop-opacity="0.6"/> <stop offset="1" stop-opacity="0.6"/> </linearGradient> </defs> </svg>}
</div>

  <div className="analytics-ratio-footer">
    <div className="analytics-ratio-item">
      <span className="analytics-dot analytics-blue"></span>
      <span>Bikes</span>
      <strong>48.1%</strong>
    </div>

    <div className="analytics-ratio-item">
      <span className="analytics-dot analytics-gray"></span>
      <span>Cars</span>
      <strong>52.9%</strong>
    </div>
  </div>
</div>

<div className="analytics-card analytics-peak-card">
  <div className="peak-header">
    <div>
      <span className="peak-small-title">
        REAL-TIME TRAFFIC DISTRIBUTION
      </span>
      <h2>Peak Timing</h2>
    </div>

    <span className="live-pill">LIVE DATA</span>
  </div>

  <div className="peak-grid">
    <div className="peak-column">
      <div className="peak-title">
  <span className="peak-icon">{Icon.clockicon}</span>
  <span className="peak-text">Peak Time</span>
</div>

      {[
        "08:00 AM - 09:30 AM",
        "05:00 PM - 06:30 PM",
        "12:30 PM - 01:30 PM",
        "07:30 AM - 08:00 AM",
        "09:30 AM - 10:30 AM",
      ].map((time, index) => (
        <div className="peak-row" key={time}>
          <span className="number">{index + 1}</span>
          <span>{time}</span>
        </div>
      ))}
    </div>

    <div className="peak-column">
      <div className="peak-title">
  <span className="peak-icon">{Icon.calendaricon}</span>
  <span className="peak-text">Peak Days</span>

</div>

      {[
  ["Wednesday", "+12%", "green"],
  ["Thursday", "+8%", "green"],
  ["Tuesday", "Stable", ""],
  ["Friday", "-4%", "red"],
  ["Monday", "-9%", "red"],
].map(([day, value, color], index) => (
  <div className="peak-row" key={day}>
    <span className="number">{index + 1}</span>

    <span>{day}</span>

    <strong className={`peak-value ${color}`}>
      {value}

      {color === "green" && (
        <span className="trend-icon">
          {Icon.uparrowicon}
        </span>
      )}

      {color === "red" && (
        <span className="trend-icon">
          {Icon.downarrowicon}
        </span>
      )}
    </strong>
  </div>
))}
    </div>
  </div>
</div>

<div className="analytics-right-column">
  <div className="analytics-turnover-card">
  <span className="turnover-car-icon">{Icon.vehicleicon}</span>

  <span className="analytics-turnover-label">TOTAL TURNOVER</span>
  <h2>1,284 <small>Vehicles</small></h2>
  <p className="turnover-change">
  <span className="turnover-badge">
    ↑14.5%
  </span>
  <span className="turnover-text">
    vs. previous period
  </span>
</p>
</div>

  <div className="analytics-export-card">
  <h2>Export Reports</h2>

  <p>
    Get the full analytics breakdown as a PDF file with reports of Daily,
    Weekly and Monthly analysis.
  </p>

  <button onClick={() => setShowReportPopup(true)}>Download</button>

  <span className="export-file-icon">
    {Icon.mailicon}
  </span>
</div>

  <div className="analytics-floor-card">
    <h2>Floor Utilization</h2>

    <div className="floor-row">
      <span>Floor 1</span>
      <strong>90%</strong>
    </div>
    <div className="floor-bar"><div style={{ width: "90%" }}></div></div>

    <div className="floor-row">
      <span>Floor 2</span>
      <strong>60%</strong>
    </div>
    <div className="floor-bar"><div style={{ width: "60%" }}></div></div>

    <div className="floor-row">
      <span>Floor 3</span>
      <strong>30%</strong>
    </div>
    <div className="floor-bar"><div style={{ width: "30%" }}></div></div>
  </div>
  <div className="analytics-average-card">

  <span className="analytics-average-label">
    AVERAGE DATA
  </span>

  <h2>All Data of Average - This Week</h2>

  <div className="analytics-average-grid">

    <div className="average-box">
      <small>REVENUE</small>
      <h3>4650</h3>
      <div className="mini-bar">
        <div style={{ width: "78%" }}></div>
      </div>
    </div>

    <div className="average-box">
      <small>OCCUPANCY</small>
      <h3>82</h3>
      <div className="mini-bar">
        <div style={{ width: "82%" }}></div>
      </div>
    </div>

    <div className="average-box">
      <small>FLOOR 1</small>
      <h3>28</h3>
      <div className="mini-bar">
        <div style={{ width: "72%" }}></div>
      </div>
    </div>

    <div className="average-box">
      <small>FLOOR 2</small>
      <h3>30</h3>
      <div className="mini-bar">
        <div style={{ width: "75%" }}></div>
      </div>
    </div>

    <div className="average-box">
      <small>FLOOR 3</small>
      <h3>24</h3>
      <div className="mini-bar">
        <div style={{ width: "60%" }}></div>
      </div>
    </div>

  </div>

</div>
</div>
<div className="analytics-card analytics-revenue-card">
  <p className="analytics-card-label">REVENUE</p>
  <h3 className="analytics-revenue-title">Total Revenue - This Week</h3>

  <div className="analytics-revenue-chart">
    <div className="analytics-revenue-y">
      <span>10K</span>
      <span>9K</span>
      <span>8K</span>
      <span>7K</span>
      <span>6K</span>
      <span>0</span>
    </div>

    <div className="analytics-revenue-area">
      <div className="analytics-revenue-lines">
        <span></span><span></span><span></span><span></span><span></span>
      </div>

      {[
        ["Mon", 130, "gray"],
        ["Tue", 165, "gray"],
        ["Wed", 185, "gray"],
        ["Thu", 105, "gray"],
        ["Fri", 220, "purple"],
        ["Sat", 130, "gray"],
        ["Sun", 65, "dark"],
      ].map(([day, height, type]) => (
        <div className="analytics-revenue-item" key={day}>
          <div
            className={`analytics-revenue-bar analytics-revenue-${type}`}
            style={{ height: `${height}px` }}
          ></div>
          <span>{day}</span>
        </div>
      ))}
    </div>
  </div>
</div>
<div className="analytics-card analytics-occupancy-card">
  <div className="analytics-occupancy-head">
    <div>
      <h3>Occupancy Traffic</h3>
      <p>Occupancy load over a 24-hour cycle</p>
    </div>

    <div className="analytics-occupancy-legend">
      <span><i className="analytics-current-dot"></i>Current</span>
      <span><i className="analytics-avg-dot"></i>Avg. Occupancy</span>
    </div>
  </div>

  <div className="analytics-occupancy-chart">
    {[
      ["06:00 AM", 70, 45],
      ["", 95, 58],
      ["09:00 AM", 135, 90],
      ["", 220, 150],
      ["12:00 PM", 270, 270],
      ["", 235, 190],
      ["03:00 PM", 210, 120],
      ["", 155, 55],
      ["06:00 PM", 110, 35],
      ["", 75, 22],
      ["09:00 PM", 55, 18],
    ].map(([time, avg, current], index) => (
      <div className="analytics-occupancy-item" key={index}>
        <div className="analytics-occupancy-bars">
          <div
            className="analytics-occupancy-avg"
            style={{ height: `${avg}px` }}
          ></div>
          <div
            className="analytics-occupancy-current"
            style={{ height: `${current}px` }}
          ></div>
        </div>
        <span>{time}</span>
      </div>
    ))}
  </div>
</div>
        </section>
        {showReportPopup && (
  <div className="report-popup-overlay">
    <div className="report-popup">
      <button
        className="report-close-btn"
        onClick={() => setShowReportPopup(false)}
      >
        ×
      </button>

      <span className="report-label">REPORT GENERATION</span>
      <h2>Download Reports</h2>

      <label>DURATION</label>

      <div className="report-tabs">
        {["Daily", "Weekly", "Monthly"].map((type) => (
          <button
            key={type}
            className={reportType === type ? "active" : ""}
            onClick={() => setReportType(type)}
          >
            {type}
          </button>
        ))}
      </div>

      <div className="report-date-section">
  <label>CUSTOM DATE RANGE</label>

  <div className="report-row">
    <div>
      <label className="popup-small-label">FROM</label>
      <div className="report-input">
  <span className="report-calendar-icon">
    {Icon.calendarpopicon}
  </span>

  <span>May 24, 2025</span>
</div>
    </div>

    <div>
      <label className="popup-small-label">TO</label>
      <div className="report-input">
  <span className="report-calendar-icon">
    {Icon.calendarpopicon}
  </span>

  <span>May 24, 2025</span>
</div>
    </div>
  </div>
</div>

      <div className="report-row">
        <div>
          <label className="popup-small-label">DOWNLOAD FORMAT</label>
          <div className="report-input report-format-input">
  <span>PDF</span>
  <span className="report-down-icon">{Icon.downpopicon}</span>
</div>
        </div>

        <div>
          <label className="popup-small-label">SAVE LOCATION</label>
          <div className="report-input report-location-input">
  <span>C:/Users/Admin/Desktop</span>
  <span className="report-pdf-icon">{Icon.pdfpopicon}</span>
</div>
        </div>
      </div>

      <button className="report-download-btn">
  <span className="report-download-icon">{Icon.downloadpopicon}</span>
  Download
</button>
    </div>
  </div>
)}
      </main>
    </div>
  );
}

export default Analytics;